import { NextImage } from '@apeiron/temp'
import {
  styled,
  ToggleButton,
  ToggleButtonGroup,
  Typography
} from '@mui/material'

export const ChipToggleButton = styled(ToggleButton)`
  padding: 4px 6px;
  text-transform: none;
  font-weight: 400;
  background-color: #565859;
  color: #b1b2b2;
  :hover {
    background-color: #576859;
    color: #b1b2b2;
  }
  &.Mui-selected,
  &.Mui-selected:hover {
    background-color: #e4c169;
    color: #000000;
  }

  transition: ${({ theme }) =>
    theme.transitions.create(['background-color', 'color'])};
`

export const ChipToggleButtonGroup = styled(ToggleButtonGroup)`
  flex-wrap: wrap;
  gap: 6px;

  & .MuiToggleButtonGroup-grouped,
  & .MuiToggleButtonGroup-grouped:not(:last-of-type),
  & .MuiToggleButtonGroup-grouped:not(:first-of-type) {
    border-radius: 4px;
    margin: 0;
    border: none;
  }
`

export const ChipIcon = styled(NextImage)`
  width: 18px;
  aspect-ratio: 1;
  margin: 2px 6px 2px 0px;
`

export const ChipLabel = styled(Typography)`
  font-size: 12px;
  line-height: 12px;
  font-weight: 300;
  color: unset;
  margin-right: 6px;
`
